// extracted by mini-css-extract-plugin
export default {"tooltip":"jjaSFzYop60_4ufbdyDg","title":"fLyQdsTC2yjrdylLgyFQ","subtitle":"hBExQoyOoCD92tTjSMwd"};